import React, { useState, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArticleStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const Article5 = ({ store }) => {
  store.use();
  const [activeAnchor, setActiveAnchor] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);

  const scrollToAnchor = anchorId => {
    const element = document.getElementById(anchorId);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50; // 向上的偏移值
      window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const anchors = ['大件优化', '更多调整'];
    const handleScroll = () => {
      let currentActive = '';
      for (const id of anchors) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentActive = id;
          }
        }
      }
      setActiveAnchor(currentActive);

      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      const threshold = (960 / 192) * rootFontSize;
      setShowSidebar(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.article}>
      <div className="xfe-root-article">
        <div className={cx('xfe-group-1', { ...xauCss.FADE.IN_UP() })} data-name="顶部导航条">
          <div className="xfe-layer-3" />
          <div className="xfe-group-2" data-name="组 84">
            <Link className="xfe-layer-4" data-id={'大件优化'} onClick={() => scrollToAnchor('大件优化')} />
            <Link className="xfe-layer-5" data-id={'更多调整'} onClick={() => scrollToAnchor('更多调整')} />
          </div>
        </div>
        <div className={cx('xfe-group-3', { visible: showSidebar })} data-name="侧栏导航">
          <div className="xfe-layer-6" />
          <div className="xfe-group-4" data-name="组 35">
            <Link className={cx('xfe-group-5', { active: activeAnchor === '大件优化' })} data-name="大件优化" onClick={() => scrollToAnchor('大件优化')}>
              <div className="xfe-layer-7" />
              <div className="xfe-layer-8" />
            </Link>

            <Link className={cx('xfe-group-6', { active: activeAnchor === '更多调整' })} data-name="更多调整" onClick={() => scrollToAnchor('更多调整')}>
              <div className="xfe-layer-9" />
              <div className="xfe-layer-10" />
            </Link>

            <Link className="xfe-group-7" data-name="返回顶部" onClick={scrollToTop}>
              <div className="xfe-layer-11" />
              <div className="xfe-layer-12" />
            </Link>
          </div>
        </div>
        <div className={cx('xfe-layer-13', { ...xauCss.FADE.IN_UP() })} />
        <div className={cx('xfe-group-content', { ...xauCss.FADE.IN_DOWN() })} data-name="内容区" dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </div>
  );
};

export default wrapStore(Article5, ArticleStore);
